var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLitePillIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H19C22.3137 0 25 2.68629 25 6V11C25 14.3137 22.3137 17 19 17H6C2.68629 17 0 14.3137 0 11V6Z",
    fill: "#B6B0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83334 4.25V12.75H8.92765V11.2191H7.33532V4.25H5.83334Z",
    fill: "#6C37CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0598 4.25H9.55785V12.75H11.0598V4.25Z",
    fill: "#6C37CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6798 4.25V5.74664H12.7526V12.75H14.2546V5.74664H15.3275V4.25H11.6798Z",
    fill: "#6C37CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9481 4.25V12.75H19.1667V11.2191H17.4501V9.12836H18.7375V7.59745H17.4501V5.74664H19.0876V4.25H15.9481Z",
    fill: "#6C37CE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitePillIcon);
export default __webpack_public_path__ + "static/media/lite-pill-icon.ac839fd6c8232f61a935757e14229e05.svg";
export { ForwardRef as ReactComponent };